import { render } from "./ChangeRuleModal.vue?vue&type=template&id=a9ba0fa0&ts=true"
import script from "./ChangeRuleModal.vue?vue&type=script&lang=tsx"
export * from "./ChangeRuleModal.vue?vue&type=script&lang=tsx"

import "./ChangeRuleModal.vue?vue&type=style&index=0&id=a9ba0fa0&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__